// This can be directly added to any of your `.ts` files like `router.ts`
// It can also be added to a `.d.ts` file. Make sure it's included in
// project's tsconfig.json "files"
import "vue-router"

import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router"

import appRoutes from "./modules"
export interface IntNavigation {
  title: string
  translationKey?: string
  routeName?: string
}
declare module "vue-router" {
  interface RouteMeta {
    // must be declared by every route
    isProtected?: boolean
    navigation?: IntNavigation[]
    variation?: string
    /** Workspace that owns the route, used to seed the side-nav selection on a hard load. */
    workspace?: string
    /** Sub-page identity shared pages read to configure themselves. */
    pageName?: string
  }
}

const routes: RouteRecordRaw[] = [
  ...appRoutes,
  {
    path: "/:pathMatch(.*)*",
    name: "pageNotFound",
    component: () => import("@/modules/error/PageNotFound.vue"),
    meta: {
      isProtected: true,
      variation: "404",
      navigation: [
        {
          title: "Home",
          translationKey: "common.home",
          routeName: "home"
        },
        {
          title: "Page not found",
          translationKey: "error.pageNotFound",
          routeName: ""
        }
      ]
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "is-active",
  linkExactActiveClass: "is-active",
  scrollBehavior() {
    // always scroll top
    return { top: 0 }
  }
})

export default router
